import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { useLanguageStore } from '$/store/languageStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import {
  getAssetStorageInfo,
  getAssetStorageProgressBarStyle,
} from '$/utils/assetStorage';
import { trackRoboneoVipClick, trackRoboneoVipShow } from '$/utils/vipPromptTrack';
import styles from './index.module.scss';

interface AssetStorageCardProps {
  className?: string;
  onAction: () => void;
}

/** 新版资产库侧栏容量卡片，容量缺失时隐藏以免展示错误用量。 */
function AssetStorageCard({ className, onAction }: AssetStorageCardProps) {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const subscribe = useOfficialStore((state) => state.userInfo.subscribe);
  const info = getAssetStorageInfo(subscribe);
  const progressBarStyle = getAssetStorageProgressBarStyle(info);
  const exposedRef = useRef(false);

  /** 容量数据就绪且卡片真实渲染时，每次资产库弹窗生命周期只上报一次曝光。 */
  useEffect(() => {
    if (info.isReady && !exposedRef.current) {
      trackRoboneoVipShow('asset_library_entry');
    }
    exposedRef.current = info.isReady;
  }, [info.isReady]);

  if (!info.isReady) return null;

  const actionText = info.isHighestLevel
    ? languageStore.smartcatTranslationText((v) => v.contact_us)
    : languageStore.smartcatTranslationText((v) => v.upgrade_capacity_1);

  /** 点击资产库容量 CTA；最高等级会员的“联系我们”不计入会员升级点击。 */
  const handleActionClick = () => {
    if (!info.isHighestLevel) {
      trackRoboneoVipClick('asset_library_entry');
    }
    onAction();
  };

  return (
    <div className={cn(styles.assetStorageCard, className, {
      [styles.assetStorageCardExceeded]: info.isExceeded,
    })}
    >
      <div className={styles.assetStorageRow}>
        <span>{languageStore.smartcatTranslationText((v) => v.capacity_1)}</span>
        <span>{info.usageLabel}</span>
      </div>
      <div className={styles.assetStorageTrack}>
        <span className={styles.assetStorageBar} style={progressBarStyle} />
      </div>
      <button
        type="button"
        className={cn(styles.assetStorageButton, {
          [styles.assetStorageButtonPrimary]: info.isHighestLevel,
        })}
        onClick={handleActionClick}
      >
        {actionText}
      </button>
    </div>
  );
}

export default AssetStorageCard;
